import useApi from "hooks/use_api"

const useSchedulableEmails = eventId => {
  return useApi({
    path: `events/${eventId}/schedulable_emails`,
    data: {
      fields: {
        SchedulableEmail: [
          "duration_number",
          "duration_unit",
          "duration_unit_options",
          "duration_string",
          "message",
          "attendee_types",
          "send_at",
          "send_at_time",
          "send_at_date"
        ]
      }
    }
  })
}

export default useSchedulableEmails
